import { render, staticRenderFns } from "./Boom.vue?vue&type=template&id=1d2acc13&scoped=true&"
import script from "./Boom.vue?vue&type=script&lang=js&"
export * from "./Boom.vue?vue&type=script&lang=js&"
import style0 from "./Boom.vue?vue&type=style&index=0&id=1d2acc13&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2acc13",
  null
  
)

export default component.exports